// booking/components/FormDateField.jsx
import React, { memo } from 'react';
import { TextField } from '@mui/material';

const FormDateField = memo(
  ({
    name,
    label,
    formik,
    required = false,
    error = false,
    helperText = '',
    maxDate,
    onChange,
    onBlur,
    ...props
  }) => {
    const maxDateString = maxDate ? maxDate.toISOString().split('T')[0] : undefined;

    return (
      <TextField
        InputLabelProps={{
          shrink: true,
          ...props.InputLabelProps,
        }}
        error={error}
        fullWidth
        helperText={helperText}
        inputProps={{
          max: maxDateString,
          ...props.inputProps,
        }}
        label={label}
        margin='normal'
        name={name}
        onBlur={(e) => {
          formik.handleBlur(e);
          onBlur?.(e);
        }}
        onChange={(e) => {
          formik.handleChange(e);
          onChange?.(e);
        }}
        required={required}
        size='small'
        type='date'
        value={formik.values[name] || ''}
        variant='outlined'
        {...props}
      />
    );
  }
);

FormDateField.displayName = 'FormDateField';

export default FormDateField;
